import ApiCore from '../../../services/api/utilities/core'
import apiProvider from '../../../services/api/utilities/provider'

const url = 'auth'

const apiAuth = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: true,
  patch: true,
  delete: true,
  url,
})

apiAuth.login = (data) => apiProvider.post(`${url}/login`, data, { csrf: true })

apiAuth.register = (data) => apiProvider.post(`${url}/register`, data, { csrf: true })

apiAuth.forgetPassword = (data) => apiProvider.post(`${url}/forget-password`, data, { csrf: true })

apiAuth.resetPassword = (token, data) => apiProvider.post(`${url}/reset-password/${token}`, data, { csrf: true })

apiAuth.invitedUserRegister = (token, data) => apiProvider.post(`${url}/user-registration/${token}`, data, { csrf: true })

apiAuth.checkIsUserRegistrationValid = (token) => apiProvider.getSingle(`${url}/user-registration`, token)

apiAuth.logout = () => apiProvider.getAll(`${url}/logout`)


export default apiAuth
